import { isWildCard, isColoredCard } from '../types/card.js';
function getCardSymbol(card) {
    if (card.type === 'number')
        return `number_${card.value}`;
    if (card.type === 'skip')
        return 'skip';
    if (card.type === 'reverse')
        return 'reverse';
    if (card.type === 'draw_two')
        return 'draw_two';
    return null;
}
export function canPlayCard(card, topCard, currentColor) {
    if (isWildCard(card)) {
        return true;
    }
    if (isColoredCard(card) && card.color === currentColor) {
        return true;
    }
    const cardSymbol = getCardSymbol(card);
    const topSymbol = getCardSymbol(topCard);
    if (cardSymbol !== null && topSymbol !== null && cardSymbol === topSymbol) {
        return true;
    }
    return false;
}
export function getPlayableCards(hand, topCard, currentColor) {
    return hand.filter(card => canPlayCard(card, topCard, currentColor));
}
export function isValidWildDrawFour(hand, currentColor) {
    return !hand.some(card => isColoredCard(card) && card.color === currentColor);
}
export function canRespondToDrawStack(card, topCard, houseRules) {
    if (!houseRules)
        return false;
    return ((houseRules.stackDrawTwo && card.type === 'draw_two' && topCard.type === 'draw_two') ||
        (houseRules.stackDrawFour && card.type === 'wild_draw_four' && topCard.type === 'wild_draw_four') ||
        (houseRules.crossStack && ((card.type === 'draw_two' && topCard.type === 'wild_draw_four') ||
            (card.type === 'wild_draw_four' && topCard.type === 'draw_two'))) ||
        (houseRules.reverseDeflectDrawTwo && card.type === 'reverse' && topCard.type === 'draw_two') ||
        (houseRules.reverseDeflectDrawFour && card.type === 'reverse' && topCard.type === 'wild_draw_four') ||
        (houseRules.skipDeflect && card.type === 'skip'));
}
export function isExactJumpInMatch(card, topCard) {
    return (card.type === topCard.type &&
        card.color === topCard.color &&
        (card.type !== 'number' || (topCard.type === 'number' && card.value === topCard.value)));
}
//# sourceMappingURL=validation.js.map